export default "__VITE_ASSET__Bv7Wsd7i__"